import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

type Props = {
  handlerCloseModal: Function
}

const APIRules: React.FC<Props> = ({ handlerCloseModal }) => {
  const { t } = useTranslation();

  return (
    <div style={{
      overflow: 'hidden',
    }}
    >

      <div className="center_txt">
        <h3 className="index_sort sort1">
          {t('pbRules.sunTitle1')}
        </h3>
        <p>
          {t('pbRules.subliT1_1')}
          {' '}
          <br />
          {t('pbRules.subliT1_1_desc')}
          <br />
          {t('pbRules.subliT1_2')}
          {' '}
          <br />
          {t('pbRules.subliT1_2_desc')}
        </p>
        {/* <h3
          className="index_sort sort2"
          style={{
            margin: '0.2rem 0',
          }}
        >
          {t('pbRules.sunTitle2')}
        </h3>

        <h3 className="index_sort sort3">
          {t('pbRules.sunTitle3')}
        </h3>
        <p>
          <strong>·Path:</strong>
          {' '}
          <br />
          {t('pbRules.subliT3_1_desc')}
          {' '}
          <br />
          {t('pbRules.subliT1_1')}
          {' '}
          pageNum
        </p>
        <p style={{
          margin: '0.1rem 0',
        }}
        >
          <strong>·Query:</strong>
          {' '}
          <br />
          {t('pbRules.subliT3_2_desc')}
          <br />
          {t('pbRules.subliT1_1')}
          {' '}
          ag0, arg1
        </p>
        <p>
          <strong>·Body:</strong>
          {' '}
          <br />
          {t('pbRules.subliT3_3_desc')}
        </p>
        <h3
          className="index_sort sort4"
          style={{
            marginTop: '0.2rem',
          }}
        >
          {t('pbRules.sunTitle4')}
        </h3>
        <h3
          className="index_sort sort5"
          style={{
            marginTop: '0.2rem',
          }}
        >
          {t('pbRules.sunTitle5')}
        </h3>
        <p>
          {t('pbRules.subliT5_1_desc')}
        </p>
        <p>
          {t('pbRules.subliT5_2_desc')}
        </p>
        <h3
          className="index_sort sort6"
          style={{
            marginTop: '0.2rem',
          }}
        >
          {t('pbRules.sunTitle6')}
        </h3>
        <p>
          {t('pbRules.subliT6_1_desc')}
        </p>
        <p>
          {t('pbRules.subliT6_2_desc')}
        </p>
        <h3
          className="index_sort sort7"
          style={{
            marginTop: '0.2rem',
          }}
        >
          {t('pbRules.sunTitle7')}
        </h3> */}
      </div>
      {/* eslint-disable-next-line max-len */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={styles.got_btn}
        onClick={() => {
          handlerCloseModal();
        }}
      >
        {t('pbRules.closeTxt')}
      </div>
    </div>
  );
};

export default APIRules;
